<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <a routerLink="/operational-dashboard/cvd-dongle-info">CVD Dongle Info</a>
  </div>
</div>
<mat-divider></mat-divider>

<div class="content-box-content">
  <mat-table [dataSource]="dataSource" matSort>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    <!-- Workstation Name Column -->
    <ng-container matColumnDef="workstationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Workstation</mat-header-cell>
      <mat-cell *matCellDef="let cvdDongleInfoRecord">
        <label style="word-break: break-word;">{{cvdDongleInfoRecord.workstationName}}</label>
      </mat-cell>
    </ng-container>

    <!-- Expires Column -->
    <ng-container matColumnDef="expires">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Expiration</mat-header-cell>
      <mat-cell *matCellDef="let cvdDongleInfoRecord">
        <label style="word-break: break-word;">{{cvdDongleInfoRecord.expires  | date:'short'}}</label>
      </mat-cell>
    </ng-container>

    <!-- PinPlay Credits Remaining Column -->
    <ng-container matColumnDef="pinPlayCreditsRemaining">
      <mat-header-cell *matHeaderCellDef mat-sort-header>PinPlay Credits</mat-header-cell>
      <mat-cell *matCellDef="let cvdDongleInfoRecord">
        <label style="word-break: break-word;">{{cvdDongleInfoRecord.pinPlayCreditsRemaining}}</label>
      </mat-cell>
    </ng-container>

    <!-- Patronus Credits Remaining Column -->
    <ng-container matColumnDef="patronusCreditsRemaining">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Patronus Credits</mat-header-cell>
      <mat-cell *matCellDef="let cvdDongleInfoRecord">
        <label style="word-break: break-word;">{{cvdDongleInfoRecord.patronusCreditsRemaining}}</label>
      </mat-cell>
    </ng-container>

    <!-- Patronus Version Column -->
    <ng-container matColumnDef="patronusVersion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Patronus Version</mat-header-cell>
      <mat-cell *matCellDef="let cvdDongleInfoRecord">
        <label style="word-break: break-word;">{{cvdDongleInfoRecord.patronusVersion}}</label>
      </mat-cell>
    </ng-container>
  </mat-table>
</div>
